import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Wrapper, Counter } from "./styles/positions-filled-styles";

export interface IPositionsFilledProps {
  positionsFilled?: number;
  numberOfPositions?: number;
}

const PositionsFilled: FunctionComponent<IPositionsFilledProps> = ({
  positionsFilled,
  numberOfPositions,
}) => (
  <Wrapper
    data-tip="This displays the number of offers accepted, out of the number of positions available on this role."
    data-for="positions-filled-tooltip"
  >
    Positions filled:{" "}
    <Counter>
      {positionsFilled}/{numberOfPositions}
    </Counter>
    <FontAwesomeIcon icon={faInfoCircle} />
  </Wrapper>
);

PositionsFilled.propTypes = {
  positionsFilled: PropTypes.number,
  numberOfPositions: PropTypes.number,
};

PositionsFilled.defaultProps = {
  positionsFilled: null,
  numberOfPositions: null,
};

export default PositionsFilled;
